import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import React from "react";
import { useApplicationStateValue } from "../../application/Application";
import { useHistory } from "react-router";
import routes from "../../config/routes";

const StyledSpeakerImage = styled.img`
    object-fit: cover;
    object-position: top;
    height: 20vw;
    width: 20vw;
    border-radius: 15px;
`;

const StyledSpeakerName = styled(Box)`
    width: ${({ theme }) => theme.sizes[3]}px;
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    line-height: 15px;
    text-align: center;
    justify-content: center;
`;

const StyledSpeaker = styled(Flex)`
    flex-direction: column;
    flex-wrap: wrap;
    margin: 0px 2px;
    align-items: center;
    justify-content: center;
`;

const StyledSpeakers = styled(Flex)`
    padding: 5% 5% 2% 5%;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-x: auto;
`;

const ImageSlider = ({ id }) => {
    const { appData } = useApplicationStateValue();
    const history = useHistory();
    let speakers = null;
    let moderators = [];

    if (appData !== null) {
        const { forumPanels, forumSpeakers } = appData;

        forumPanels[id].moderators.forEach(moderator => {
            const moderatorObj = forumSpeakers[moderator];
            moderators.push(
                <Box
                    key={`speaker#${moderator}`}
                    onClick={() => {
                        history.push(`${routes.SPEAKERS_DETAILS}${moderator}`);
                    }}>
                    <StyledSpeaker>
                        <StyledSpeakerImage src={moderatorObj.imgUrl} alt=""></StyledSpeakerImage>
                        {/*<StyledSpeakerImage marginY="auto" marginX={[4,5]}><img style={{borderRadius: "15px", objectFit: "cover"}} margin="3px" width="100%" height="100%" src={speaker.imgUrl} alt={`speaker#${speakerId}`}/></StyledSpeakerImage>*/}
                        <StyledSpeakerName>{moderatorObj.name}</StyledSpeakerName>
                    </StyledSpeaker>
                </Box>
            );
        });

        speakers = forumPanels[id].speakers.map(speakerId => {
            const speaker = forumSpeakers[speakerId];
            return (
                <Box
                    key={`speaker#${speakerId}`}
                    onClick={() => {
                        history.push(`${routes.SPEAKERS_DETAILS}${speakerId}`);
                    }}>
                    <StyledSpeaker>
                        <StyledSpeakerImage src={speaker.imgUrl} alt=""></StyledSpeakerImage>
                        {/*<StyledSpeakerImage marginY="auto" marginX={[4,5]}><img style={{borderRadius: "15px", objectFit: "cover"}} margin="3px" width="100%" height="100%" src={speaker.imgUrl} alt={`speaker#${speakerId}`}/></StyledSpeakerImage>*/}
                        <StyledSpeakerName>{speaker.name}</StyledSpeakerName>
                    </StyledSpeaker>
                </Box>
            );
        });
    }

    return <StyledSpeakers paddingX={[3, 4]}>{[...moderators, ...speakers]}</StyledSpeakers>;
};

export default ImageSlider;
